import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "p-label" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "p-required" }, "*", -1)
const _hoisted_3 = { class: "p-label" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "p-required" }, "*", -1)
const _hoisted_5 = { class: "p-label" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "p-required" }, "*", -1)
const _hoisted_7 = { class: "p-field mb-4" }
const _hoisted_8 = { class: "p-label" }
const _hoisted_9 = { class: "p-field mb-4" }
const _hoisted_10 = { class: "p-label" }
const _hoisted_11 = { class: "grid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileCard = _resolveComponent("ProfileCard")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ProfileCard, {
      name: $setup.state.data.name,
      credits: $setup.state.data.credits,
      tokens: $setup.state.data.tokens
    }, null, 8, ["name", "credits", "tokens"]),
    _createElementVNode("form", {
      onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => ($setup.handleSubmit(!$setup.v$.$invalid)), ["prevent"])),
      class: "_form _relative"
    }, [
      ($setup.state.isLoading)
        ? (_openBlock(), _createBlock(_component_Loader, {
            key: 0,
            isOverlay: ""
          }))
        : _createCommentVNode("", true),
      _createElementVNode("label", {
        class: _normalizeClass(["p-field mb-4", { 'p-invalid': $setup.v$.email.$invalid && $setup.v$.email.$dirty }])
      }, [
        _createElementVNode("span", _hoisted_1, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('email')), 1),
          _hoisted_2
        ]),
        _createVNode(_component_InputText, {
          type: "text",
          modelValue: $setup.v$.email.$model,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.v$.email.$model) = $event)),
          onBlur: _cache[1] || (_cache[1] = ($event: any) => ($setup.v$.email.$touch()))
        }, null, 8, ["modelValue"])
      ], 2),
      _createElementVNode("label", {
        class: _normalizeClass(["p-field mb-4", { 'p-invalid': $setup.v$.name.$invalid && $setup.v$.name.$dirty }])
      }, [
        _createElementVNode("span", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('company_page.contact_person')), 1),
          _hoisted_4
        ]),
        _createVNode(_component_InputText, {
          type: "text",
          modelValue: $setup.v$.name.$model,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.v$.name.$model) = $event)),
          onBlur: _cache[3] || (_cache[3] = ($event: any) => ($setup.v$.name.$touch()))
        }, null, 8, ["modelValue"])
      ], 2),
      _createElementVNode("label", {
        class: _normalizeClass(["p-field mb-4", { 'p-invalid': $setup.v$.phone.$invalid && $setup.v$.phone.$dirty }])
      }, [
        _createElementVNode("span", _hoisted_5, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('company_page.phone')), 1),
          _hoisted_6
        ]),
        _createVNode(_component_InputText, {
          type: "text",
          modelValue: $setup.v$.phone.$model,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.v$.phone.$model) = $event)),
          onBlur: _cache[5] || (_cache[5] = ($event: any) => ($setup.v$.phone.$touch()))
        }, null, 8, ["modelValue"])
      ], 2),
      _createElementVNode("label", _hoisted_7, [
        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t('company_page.credits')), 1),
        _createVNode(_component_InputNumber, {
          type: "text",
          modelValue: $setup.v$.credits.$model,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.v$.credits.$model) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("label", _hoisted_9, [
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('company_page.available_tokens')), 1),
        _createVNode(_component_InputNumber, {
          type: "text",
          modelValue: $setup.v$.tokens.$model,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.v$.tokens.$model) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createVNode(_component_Button, {
          class: "p-button-big col mt-3 ml-2 mr-2",
          type: "submit",
          disabled: $setup.state.isSubmiting
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('save_change')), 1)
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_Button, {
          class: "p-button-big p-button-outlined p-button-gray p-button-icon-right col mt-3 ml-2 mr-2",
          onClick: $setup.toggleBlock
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t($setup.state.data.is_active ? 'unlock' : 'block')), 1),
            _createVNode(_component_Icon, {
              name: $setup.state.data.is_active ? 'lock' : 'unlock'
            }, null, 8, ["name"])
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ], 32)
  ], 64))
}